import { Injectable } from '@angular/core';
import {SelectItem} from "primeng/api";

@Injectable()
export class DictionaryService {

  horseBreeds: Map<string, string> = new Map();
  bookHorseBreeds: Map<string, string> = new Map();
  horseSexes: Map<string, string> = new Map();
  arabianDocuments: Map<string, string> = new Map();
  thoroughbredDocuments: Map<string, string> = new Map();
  jockeyStatus: Map<string, string> = new Map();
  raceGroup: Map<string, string> = new Map();
  raceSubTypes: Map<string, string> = new Map();
  raceHorseEventTypes: Map<string, string> = new Map();

  constructor() {
    this.createBreeds();
    this.createBookBreeds();
    this.createHorseSexes();
    this.createArabianDocuments();
    this.createThoroughbredDocuments();
    this.createJockeyStatus();
    this.createRaceSubTypes();
    this.createRaceGroup();
    this.createRaceHorseEventTypes();
  }

  private createBreeds(){
    this.horseBreeds.set("ARABIAN", "Czysta krew arabska");
    this.horseBreeds.set("THOROUGHBRED", "Pełna krew angielska");
    this.horseBreeds.set("STANDARDBRED", "Kłusak");
    this.horseBreeds.set("ANGLO_ARABIAN", "Półkrew");
  }

  private createBookBreeds(){
    this.bookHorseBreeds.set("ARABIAN", "Czysta krew arabska");
    this.bookHorseBreeds.set("THOROUGHBRED", "Pełna krew angielska");
  }

  private createHorseSexes(){
    this.horseSexes.set("STALLION", "ogier");
    this.horseSexes.set("GELDING", "wałach");
    this.horseSexes.set("MARE", "klacz");
  }

  private createArabianDocuments(){
    this.arabianDocuments.set("REGISTRATION_CERTIFICATE", "Zaświadczenie o wpisie");
    this.arabianDocuments.set("REPRODUCE_PERMISSION", "Zezwolenie na dopuszczenie reproduktora do rozrodu");
    this.arabianDocuments.set("EXPORT_CERTIFICATE", "Świadectwo eksportowe");
    this.arabianDocuments.set("EXPORT_BREEDING_CERTIFICATE", "Eksportowe świadectwo pokrycia");
    this.arabianDocuments.set("USE_SPERM_PERMISSION", "Zezwolenie na użycie nasienia");
    this.arabianDocuments.set("REGISTRATION_CERTIFICATE_2", "Świadectwo wpisania konia");
  }

  private createThoroughbredDocuments(){
    this.thoroughbredDocuments.set("REGISTRATION_CERTIFICATE", "Zaświadczenie o wpisie");
    this.thoroughbredDocuments.set("REPRODUCE_PERMISSION", "Zezwolenie na dopuszczenie reproduktora do rozrodu");
    this.thoroughbredDocuments.set("EXPORT_CERTIFICATE", "Świadectwo eksportowe");
    this.thoroughbredDocuments.set("BREEDING_CLEARANCE_NOTIFICATION", "BCN - breeding clearance notification");
    this.thoroughbredDocuments.set("GENERAL_NOTIFICATION_OF_MOVEMENT_ENG", "GNM(ENG) - general notification of movement");
    this.thoroughbredDocuments.set("GENERAL_NOTIFICATION_OF_MOVEMENT_ENG_PL", "GNM(ENG/PL) - general notification of movement");
  }

  private createJockeyStatus(){
    this.jockeyStatus.set("STUDENT", "uczeń");
    this.jockeyStatus.set("SENIOR_STUDENT", "starszy uczeń");
    this.jockeyStatus.set("INTERN", "praktykant dźokejski");
    this.jockeyStatus.set("CANDIDATE", "kandydat dżokejski");
    this.jockeyStatus.set("JOCKEY", "dźokej");
  }

  private createRaceSubTypes() {
	this.raceSubTypes.set("HANDICAPS", "H");
	this.raceSubTypes.set("WEIGHTED", "W");
  }

  private createRaceGroup(){
    this.raceGroup.set("GROUP_I", "Grupa I");
    this.raceGroup.set("GROUP_II", "Grupa II");
    this.raceGroup.set("GROUP_III", "Grupa III");
    this.raceGroup.set("GROUP_IV", "Grupa IV");
    this.raceGroup.set("GROUP_NONE", "Pozagrupowe");
    this.raceGroup.set("STEEPLECHASE", "Przeszkody");
    this.raceGroup.set("HURDLE", "Płoty");
    this.raceGroup.set("TRIAL", "Próbna");
    this.raceGroup.set("SUMMER", "Letnia");
    this.raceGroup.set("HUNTER", "Hunter");
    this.raceGroup.set("SLED", "Zaprzęg");
    this.raceGroup.set("SADDLE", "W siodle");
  }

  private createRaceHorseEventTypes(){
    this.raceHorseEventTypes.set("CHANGE_RACE_OWNER", "Zmiana właściciela");
    this.raceHorseEventTypes.set("CHANGE_TRAINER", "Zmiana trenera");
	this.raceHorseEventTypes.set("CASTRATION", "Kastracja");
  }

  public getHorseSexSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.horseSexes);
  }

  public getHorseBreedSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.horseBreeds);
  }

  public getBookHorseBreedSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.bookHorseBreeds);
  }

  public getArabianDocumentsSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.arabianDocuments);
  }

  public getThoroughbredDocumentsSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.thoroughbredDocuments);
  }

  public getJockeyStatusSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.jockeyStatus);
  }

  public getRaceGroup(): SelectItem[] {
    return this.convertToSelectItem(this.raceGroup);
  }

  public getRaceSubTypes(): SelectItem[] {
	return this.convertToSelectItem(this.raceSubTypes);
  }

  public getRaceHorseEventTypes(): SelectItem[] {
    return this.convertToSelectItem(this.raceHorseEventTypes);
  }

  public convertToSelectItem(map: Map<string, any>): SelectItem[] {
    const items: SelectItem[] = [];
    map.forEach((value, key) => {
      items.push({label: value, value: key});
    });
    return items;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/dictionary.service.ts